/* eslint-disable no-unused-vars */
import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { createBrowserHistory } from 'history';

import { I18nProvider } from '../contexts/I18nProvider';
import { NotificationsProvider } from '../contexts/NotificationsContext';
import { AuthProvider } from '../contexts/AuthProvider';

import Loader from '../components/loaders/Loader';
import Layout from '../layouts/Layout';
import Routes from './Routes';

const BASE_URL = process.env.REACT_APP_BASENAME_URL;

const customHistory = createBrowserHistory();

function App() {
  return (
    <Suspense fallback={<Loader />}>
      <BrowserRouter basename={BASE_URL} history={customHistory}>
        <AuthProvider>
          <I18nProvider>
            <NotificationsProvider>
              <Layout>
                <Routes />
              </Layout>
            </NotificationsProvider>
          </I18nProvider>
        </AuthProvider>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
